<template>
  <v-textarea
    v-model="messagesComputed"
    solo
    flat
    hide-details
    rows="1"
    @keyup.enter="sendMessage()"
    class="chatgpt-textarea"
    placeholder="ارسال پیام به هوش مصنوعی..."
  >
    <template v-slot:prepend-inner>
      <v-btn
        v-if="endMessage"
        :disabled="limited"
        @click="$emit('send')"
        :loading="loading"
        color="rgb(167, 165, 165)"
        fab
        small
        class="elevation-1"
      >
        <v-icon color="white">mdi-arrow-up</v-icon>
      </v-btn>
      <v-btn
        :disabled="limited"
        v-else
        color="rgb(167, 165, 165)"
        fab
        small
        class="elevation-1"
      >
        <v-icon color="white">mdi-square</v-icon>
      </v-btn>

      <!-- دکمه تنظیمات -->
      <div class="text-center">
        <v-menu transition="slide-x-transition" bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="rgb(167, 165, 165)"
              dark
              v-bind="attrs"
              v-on="on"
              rounded
            >
              تنظیمات
              <v-icon color="white">mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <v-checkbox
                v-model="enter"
                label="با فشردن دکمه Enter پیام ارسال نشود"
                color="red"
                hide-details
              ></v-checkbox>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-textarea>
</template>

<script>
export default {
  name: "sendBoxBot",

  props: {
    value: [String],
    loading: Boolean,
    limited: Boolean,
    endMessage: Boolean,
  },

  data() {
    return {
      enter: false,
    };
  },

  computed: {
    messagesComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    sendMessage() {
      if (this.enter && !this.limited && this.endMessage) {
        this.$emit("send");
      }
    },
  },
};
</script>

<style scoped>
.v-input.chatgpt-textarea {
  padding: 0 2rem;
  width: 100%;
  position: absolute;
  bottom: 1rem;
}

.v-input.chatgpt-textarea >>> .v-input__slot {
  background: rgb(235, 233, 233);
  padding: 0.5rem 1.5rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column-reverse;
}

.v-input.chatgpt-textarea >>> .v-input__slot:before,
.v-input.chatgpt-textarea >>> .v-input__slot:after {
  display: none !important;
}

.v-input.chatgpt-textarea >>> textarea {
  resize: none !important;
  padding: 1rem 1.5rem;
}

.v-input.chatgpt-textarea >>> .v-input__prepend-inner {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 1rem 0.5rem;
}

.chatgpt-send-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgb(167, 165, 165);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all linear 0.2s;
}

.chatgpt-send-btn:hover {
  background: #aed6f1 !important;
  color: white;
}
</style>
